export const iconFontAwesomeEmojiFaceSmileWink = (
	<i className="fa-solid fa-face-smile-wink"></i>
);
